// eslint-disable-next-line react-hooks/rules-of-hooks

import { Card, Grid } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import ProfileSetting from './AnswerComponents/ProfileSetting';
import Tagged from './AnswerComponents/Tagged';
import { Box } from '@mui/system';
import AnswerHeader from './AnswerComponents/AnswerHeader';
import useStyles from '../indexcss';

const Answers = () => {
  const location = useLocation();
  const { state } = location;
  const classes = useStyles();

  React.useEffect(() => {
    console.log('State from navigation:', state);
  }, [state]);

  return (
    <>
      <Card className={classes.RequestMainCard1}>
        <Box>
          <AnswerHeader />
        </Box>
        <Grid container spacing={2} className={classes.borderGrid}>
          <Grid item xs={12} md={7}>
            <ProfileSetting />
          </Grid>
          <Grid item xs={12} md={4} className={classes.taggedBorder}>
            <Tagged />
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default Answers;
